module.exports = __webpack_public_path__ + "static/wordpress-31432c9f75e225867d33519698d1ecc5.svg";